import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'User/GetAllUsers', method: 'GET', body: null, token: token })
}
